// Maps known EVU tester validation error messages to user-friendly descriptions.
// Each entry needs:
//   test(msg)     — returns true when the pattern matches
//   messageId     — i18n key (used if the key exists in locales)
//   defaultMessage — shown directly; also used as the react-intl fallback
//
// Add new entries here when a technical EVU error needs a clearer explanation.
const EVU_ERROR_MAPPINGS = [
  {
    test: msg => /stream_sources.*type.*invalid|type.*not in the list/i.test(msg),
    messageId: "roomTemplate.evu.error.streamSourceInvalidType",
    defaultMessage:
      'Una fuente de stream tiene un tipo no válido. Los valores permitidos son: "stream", "DewarpedStream", "overlay", "image". Revisa el campo Tipo en la sección Fuentes de vídeo/audio.',
  },
  {
    test: msg => /preselected/i.test(msg) && /mixer/i.test(msg),
    messageId: "roomTemplate.evu.error.mixerPreselectedRequired",
    defaultMessage:
      'El mixer no tiene ninguna fuente preseleccionada. En la sección "Fuentes de vídeo/audio" debes marcar el checkbox "Preselected" en al menos una fuente de vídeo. Esto indica qué cámara se mostrará por defecto al iniciar el evento.',
  },
];

/**
 * Resolves a raw EVU error message to a human-readable string.
 * If no mapping matches, returns the original message unchanged.
 *
 * @param {string} msg  - raw error message from the EVU tester
 * @param {object} intl - react-intl intl object (from injectIntl / prop)
 * @returns {string}
 */
export const resolveEvuErrorMessage = (msg, intl) => {
  if (!msg || typeof msg !== "string") return msg;
  for (const mapping of EVU_ERROR_MAPPINGS) {
    if (mapping.test(msg)) {
      return intl.formatMessage({
        id: mapping.messageId,
        defaultMessage: mapping.defaultMessage,
      });
    }
  }
  return msg;
};
